module.exports = __webpack_public_path__ + "img/img2.112c135d.jpg";